/**
 * 船舶
 */
const uri = '/v1/typhoon-ship-type'
const uri1 = '/v1/typhoon-ais-base'

export const list = uri + "/list";
export const getCompany = uri1 + "/get_company_name";
export const getShipType = uri1 + "/get_types";
export const getShipList = uri1 + "/list";
export const getDetailById = uri1;
